// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterListStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterList";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { color } from "@rc/XDL/Utilities";
import { css } from "styled-components";

filterListStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 0;
        border: 1px solid ${color("common.border")};
    `,
};

filterListStyles.filterText = {
    ...filterListStyles.filterText,
    css: css`
        color: ${color("common.ui6")};
        background-color: ${color("common.border")};
        font-size: 18px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 24px;
        margin: 0;
        padding: 9px 12px 7px 12px;
        width: 100%;
    `,
};

filterListStyles.clearAllLink = {
    css: css`
        margin: 8px 0 8px 12px;
    `,
    color: "primary",
    typographyProps: {
        size: 14,
    },
};

filterListStyles.filterTag = {
    ...filterListStyles.filterTag,
    css: css`
        margin: 12px 12px 0 12px;
        padding: 4px 30px 4px 5px;
        max-width: calc(100% - 24px);
        ${TypographyStyle} {
            font-size: 13px;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        &&&&&&&& button {
            top: unset;
            -webkit-transform: unset;
            transform: unset;
            bottom: 8px;
            display: flex;
            align-items: flex-end;
        }
    `,
};
